import { ImageCell } from '@/components/shared/ImageCell';
import type { AttractionType } from '@/config/objects/attraction-types';

interface AttractionTypeImageCellProps {
  attractionType?: AttractionType;
  size?: 'sm' | 'lg';
}

/**
 * Editable attraction type image cell component with upload and delete actions
 */
export function AttractionTypeImageCell({ attractionType, size = 'sm' }: AttractionTypeImageCellProps) {
  return (
    <ImageCell
      item={attractionType}
      endpoint="/attraction-types"
      entityName="Attraction Type"
      imageLabel="Attraction Type Image"
      getFeaturedImage={(item) => item.featuredImage}
      getItemId={(item) => item.id}
      size={size}
    />
  );
}
